import React from "react";
import {
	Button,
	Modal,
	Select,
	Textfield,
} from "../../../../../components/core";
import { NumericFormat, PatternFormat } from "react-number-format";
import { DOOR_SIZES } from "../../../../../constants/graphql/global-queries";
import { useDispatch, useSelector } from "react-redux";
import { setDoorSizesList } from "../../../../../features/locker-fees/add-user-fees/add-user-fees-slice";
import { useQuery } from "@apollo/client";
import { Card } from "primereact/card";
export default function PackageShipoutCostTable({
	items = [],
	lockerType,
	partnerType,
	addedData,
	handleAddDataItem,
	handleModifyAddedItems,
	handleModifyDataItems,
	disabled = false,
}) {
	const dispatch = useDispatch();
	const doorSizes = useQuery(DOOR_SIZES);
	const doorSizesList = useSelector((state) => state.addUserFee.doorSizesList);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	React.useEffect(() => {
		if (doorSizes.data) {
			let tempVar = [];
			doorSizes.data.doorSizes.map((element) => {
				tempVar.push({
					value: element.doorSizeId,
					name: element.doorSize,
				});
			});
			dispatch(setDoorSizesList(tempVar));
		}
	}, [doorSizes.data]);
	return (
		<>
			<Card>
				<div className="my-4 text-black">
					<div className="bg-primary-primaryYellowLight text-center p-4 border-2 border-gray-400 font-bold text-lg">
						<p>PACKAGE SHIPOUT COST</p>
						<p>
							for {lockerType} Locker - {partnerType} Partner
						</p>
					</div>
					<table className="w-full border-2 border-gray-400">
						<thead>
							<tr className="bg-primary-primaryYellow h-16">
								<th className="text-left p-2">Door Sizes</th>
								<th className="text-left p-2">
									Commission Percentage on Shipout Fee
								</th>
								<th className="text-left p-2">Initial Shipout Fee </th>
								<th className="text-left p-2">Initial Free Hours</th>
								<th className="text-left p-2">
									Overstay charges after Initial Free Hours
								</th>
								<th className="text-left p-2">Max Overstay Charge</th>
							</tr>
						</thead>
						<tbody>
							{items.map((data, key) => {
								return (
									<tr className="h-12 even:bg-gray-100 bg-white" key={key}>
										<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
											<Select
												disabled={disabled}
												items={doorSizesList}
												value={data.doorSizeId}
												name="doorSizeId"
												id={key}
												onChange={handleModifyDataItems}
											/>
										</td>
										<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
											<div className="flex gap-2">
												<p className="my-auto"></p>{" "}
												<Textfield
													disabled={disabled}
													placeholder="0.00"
													name="commissionPercent"
													value={data.commissionPercent}
													id={key}
													onChange={(e) => {
														var numberPattern = /^\d+(\.\d{0,4})?$/;
														if (
															numberPattern.test(e.target.value) ||
															e.target.value === ""
														) {
															if (
																parseFloat(e.target.value) <= 99.99 ||
																e.target.value === ""
															)
																handleModifyDataItems(e);
														}
													}}
												/>
											</div>
										</td>
										<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
											<div className="flex gap-2">
												<p className="my-auto">P</p>{" "}
												<Textfield
													disabled={disabled}
													name="initialShipoutFee"
													value={data.initialShipoutFee}
													id={key}
													placeholder="0.00"
													onChange={(e) => {
														var numberPattern = /^\d+(\.\d{0,2})?$/;
														if (
															numberPattern.test(e.target.value) ||
															e.target.value === ""
														) {
															if (
																parseFloat(e.target.value) <= 1000000000 ||
																e.target.value === ""
															)
																handleModifyDataItems(e);
														}
													}}
												/>
											</div>
										</td>
										<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
											<div className="flex gap-2">
												<Textfield
													disabled={disabled}
													name="initialFreeHours"
													id={key}
													placeholder="XXX"
													value={data.initialFreeHours}
													onChange={(e) => {
														var numberPattern = /^(\d+)?$/;

														if (
															numberPattern.test(e.target.value) &&
															(parseFloat(e.target.value) <= 720 ||
																e.target.value === "")
														) {
															handleModifyDataItems(e);
														}
													}}
												/>{" "}
												<p className="my-auto">hrs</p>
											</div>
										</td>
										<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
											<div className="flex gap-2">
												<p className="my-auto">P</p>{" "}
												<Textfield
													disabled={disabled}
													// value={data[key].excessFeePerInc}
													value={data.excessFeePerInc}
													placeholder="0.00"
													name="excessFeePerInc"
													id={key}
													onChange={(e) => {
														var numberPattern = /^\d+(\.\d{0,2})?$/;
														if (
															numberPattern.test(e.target.value) ||
															e.target.value === ""
														) {
															if (
																parseFloat(e.target.value) <= 1000000000 ||
																e.target.value === ""
															)
																handleModifyDataItems(e);
														}
													}}
												/>{" "}
												<p className="my-auto"> / </p>
												<p className="my-auto">every</p>{" "}
												<Textfield
													disabled={disabled}
													placeholder="XXX"
													value={data.incByHours}
													name="incByHours"
													id={key}
													onChange={(e) => {
														var numberPattern = /^(\d+)?$/;

														if (
															numberPattern.test(e.target.value) &&
															(parseFloat(e.target.value) <= 720 ||
																e.target.value === "")
														) {
															handleModifyDataItems(e);
														}
													}}
												/>
												<p className="my-auto">hrs</p>
											</div>
										</td>
										<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
											<div className="flex gap-2">
												<p className="my-auto">P</p>{" "}
												<Textfield
													disabled={disabled}
													value={data.maxOverstayCharge}
													placeholder="0.00"
													name="maxOverstayCharge"
													id={key}
													onChange={(e) => {
														var numberPattern = /^\d+(\.\d{0,2})?$/;
														if (
															numberPattern.test(e.target.value) ||
															e.target.value === ""
														) {
															if (
																parseFloat(e.target.value) <= 1000000000 ||
																e.target.value === ""
															)
																handleModifyDataItems(e);
														}
													}}
												/>
											</div>
										</td>
									</tr>
								);
							})}
							{addedData &&
								addedData.map((data, key) => {
									return (
										<tr className="h-12 even:bg-gray-100 bg-white" key={key}>
											<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
												<Select
													items={doorSizesList}
													value={addedData[key].doorSizeId}
													name="doorSizeId"
													id={key}
													onChange={handleModifyAddedItems}
												/>
											</td>
											<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
												<div className="flex gap-2">
													<p className="my-auto"></p>{" "}
													<Textfield
														placeholder="0.00"
														name="commissionPercent"
														value={addedData[key].commissionPercent}
														id={key}
														onChange={(e) => {
															var numberPattern = /^\d+(\.\d{0,4})?$/;
															if (
																numberPattern.test(e.target.value) ||
																e.target.value === ""
															) {
																if (
																	parseFloat(e.target.value) <= 100.0 ||
																	e.target.value === ""
																)
																	handleModifyAddedItems(e);
															}
														}}
													/>
													<p className="my-auto">%</p>
												</div>
											</td>
											<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
												<div className="flex gap-2">
													<p className="my-auto">P</p>{" "}
													<Textfield
														name="initialShipoutFee"
														value={addedData[key].initialShipoutFee}
														id={key}
														placeholder="0.00"
														onChange={(e) => {
															var numberPattern = /^\d+(\.\d{0,2})?$/;
															if (
																numberPattern.test(e.target.value) ||
																e.target.value === ""
															) {
																if (
																	parseFloat(e.target.value) <= 1000000000 ||
																	e.target.value === ""
																)
																	handleModifyAddedItems(e);
															}
														}}
													/>
												</div>
											</td>
											<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
												<div className="flex gap-2">
													<Textfield
														name="initialFreeHours"
														id={key}
														placeholder="XXX"
														value={addedData[key].initialFreeHours}
														onChange={(e) => {
															var numberPattern = /^(\d+)?$/;

															if (
																numberPattern.test(e.target.value) &&
																(parseFloat(e.target.value) <= 720 ||
																	e.target.value === "")
															) {
																handleModifyAddedItems(e);
															}
														}}
													/>{" "}
													<p className="my-auto">hrs</p>
												</div>
											</td>
											<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
												<div className="flex gap-2">
													<p className="my-auto">P</p>{" "}
													<Textfield
														value={addedData[key].excessFeePerInc}
														placeholder="0.00"
														name="excessFeePerInc"
														id={key}
														onChange={(e) => {
															var numberPattern = /^\d+(\.\d{0,2})?$/;
															if (
																numberPattern.test(e.target.value) ||
																e.target.value === ""
															) {
																if (
																	parseFloat(e.target.value) <= 1000000000 ||
																	e.target.value === ""
																)
																	handleModifyAddedItems(e);
															}
														}}
													/>{" "}
													<p className="my-auto"> / </p>
													<p className="my-auto">every</p>{" "}
													<Textfield
														placeholder="XXX"
														value={addedData[key].incByHours}
														name="incByHours"
														id={key}
														onChange={(e) => {
															var numberPattern = /^(\d+)?$/;

															if (
																numberPattern.test(e.target.value) &&
																(parseFloat(e.target.value) <= 720 ||
																	e.target.value === "")
															) {
																handleModifyAddedItems(e);
															}
														}}
													/>{" "}
													<p className="my-auto">hrs</p>
												</div>
											</td>
											<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
												<div className="flex gap-2">
													<p className="my-auto">P</p>{" "}
													<Textfield
														value={addedData[key].maxOverstayCharge}
														placeholder="0.00"
														name="maxOverstayCharge"
														id={key}
														onChange={(e) => {
															var numberPattern = /^\d+(\.\d{0,2})?$/;
															if (
																numberPattern.test(e.target.value) ||
																e.target.value === ""
															) {
																if (
																	parseFloat(e.target.value) <= 1000000000 ||
																	e.target.value === ""
																)
																	handleModifyAddedItems(e);
															}
														}}
													/>
												</div>
											</td>
										</tr>
									);
								})}
							<tr className="h-12 even:bg-gray-100 bg-white">
								<td
									className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2"
									colSpan={5}
								>
									<Button
										disabled={disabled}
										className={"p-4"}
										value={"Add"}
										onClick={() => {
											let combinedDataAndAddedData = [
												...addedData,
												...(items ? items : []),
											];
											if (
												combinedDataAndAddedData.length === doorSizesList.length
											) {
												setValidation({
													icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
													title: "Error",
													message: "Maximum number of door size is reached",
													open: true,
													actions: (
														<div className="grid grid-cols-1">
															<Button
																onClick={() => setValidation({ open: false })}
																value={"OK"}
																className={"p-2"}
															/>
														</div>
													),
												});
											} else {
												handleAddDataItem();
											}
										}}
									/>
								</td>
							</tr>
						</tbody>
					</table>
					<Modal
						icon={validation.icon}
						title={validation.title}
						message={validation.message}
						open={validation.open}
						actions={validation.actions}
					/>
				</div>
			</Card>
		</>
	);
}
